import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ShopifyApp from '../shopify/ShopifyApp';
import ShopifyAuth from '../shopify/ShopifyAuth';

export default function ShopifyRoutes() {
  return (
    <Routes>
      {/* Main Shopify app route */}
      <Route path="/shopify" element={<ShopifyApp />} />

      {/* OAuth callback route */}
      <Route path="/auth/shopify/callback" element={<ShopifyAuth />} />
    </Routes>
  );
}